module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Radcliffe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ann Radcliffe (1765–1823) was an influential author of Gothic literature and one of the most popular writers of her era. In addition to "), _c('I', [_vm._v("The Mysteries of Udolpho")]), _vm._v(", her six novels include "), _c('I', [_vm._v("The Italian ")]), _vm._v("and "), _c('I', [_vm._v("The Romance of the Forest")]), _vm._v("."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EiTTi0/tc-custom/9781497684324.jpg?1701883864997",
      "alt": "This image is the cover for the book Sicilian Romance"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sicilian Romance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("What horrible history lies below the castles in the caverns of Sicily?")]), _c('br'), _c('br'), _vm._v(" Located on Sicily’s northern shore, the castle of Mazzini was home to the beautiful and clever sisters Emilia and Julia. They have lived there for years with their governess after their father, the marquis, moved to Naples with his second wife. When he unexpectedly returns with their brother Ferdinand, mysterious events begin to occur around the castle. Rooms abandoned for years suddenly have strange tenants."), _c('br'), _c('br'), _vm._v(" Visiting the castle is a valiant and handsome friend of Ferdinand named Hippolitus, who immediately catches the eyes of both Julia and her stepmother. However, the marquis has his own ideas for who Julia’s husband should be, and he will stop at nothing to get his way, no matter what the cost to his daughters."), _c('br'), _c('br'), _vm._v(" This ebook has been professionally proofread to ensure accuracy and readability on all devices.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0